import { render, staticRenderFns } from "./productParamRel.vue?vue&type=template&id=9687dea0&scoped=true"
import script from "./productParamRel.vue?vue&type=script&lang=js"
export * from "./productParamRel.vue?vue&type=script&lang=js"
import style0 from "./productParamRel.vue?vue&type=style&index=0&id=9687dea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9687dea0",
  null
  
)

export default component.exports